export default "__VITE_ASSET__BGFpEt85__"